export const THRESHOLD_MODES = {
  ABSOLUTE: "ABSOLUTE",
  PERCENTAGE: "PERCENTAGE"
};
